import { render, staticRenderFns } from "./1.vue?vue&type=template&id=35280ff8&scoped=true&"
import script from "./1.vue?vue&type=script&lang=js&"
export * from "./1.vue?vue&type=script&lang=js&"
import style0 from "./1.vue?vue&type=style&index=0&id=35280ff8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35280ff8",
  null
  
)

export default component.exports